export var GrandAlliance;
(function (GrandAlliance) {
    GrandAlliance["ORDER"] = "ORDER";
    GrandAlliance["CHAOS"] = "CHAOS";
    GrandAlliance["DEATH"] = "DEATH";
    GrandAlliance["DESTRUCTION"] = "DESTRUCTION";
    GrandAlliance["UNKNOWN"] = "UNKNOWN";
})(GrandAlliance || (GrandAlliance = {}));
